var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewBoxS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19098_753)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.727685 8.43633C0.330628 8.05454 0.330628 7.41919 0.727684 7.0374C1.10332 6.67621 1.69717 6.67621 2.0728 7.0374L5.00024 9.85225L11.9277 3.19125C12.3033 2.83006 12.8972 2.83006 13.2728 3.19125C13.6699 3.57303 13.6699 4.20839 13.2728 4.59017L5.69335 11.8781C5.30624 12.2503 4.69425 12.2503 4.30714 11.8781L0.727685 8.43633Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19098_753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    transform: "translate(0.000244141 0.000183105)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewBoxS);
export default __webpack_public_path__ + "static/media/view-box-S.d8f56ebe7e8d5a6f01997dbf30ef0be7.svg";
export { ForwardRef as ReactComponent };